const maintenanceEquipments = {
  toastr: 'Updated equipments',
  toastr1: 'Equipments SENT for maintenance successfully',
  toastr2: 'Equipments RETURNED from maintenance successfully',
};

export default maintenanceEquipments;
